import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_WIDTH } from "../constants";
import secureLocalStorage from "react-secure-storage";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "./Layout.scss";
import { useLazyGetUserQuery, usePostLogoutMutation } from "../services/auth";
import { getFromStorage, removeFromStorage } from "../helpers/storage";
import { STORAGE_KEYS } from "../constants/storageKeys";
import { resetAuth, setCredentials } from "../reducers/authSlice";
import Loader from "../constants/Loader";
import { useAppDispatch } from "../hooks/store";
import useAuth from "../hooks/useAuth";
import LogoutModal from "../components/modals";
import { useLazyReceiveNotificationQuery } from "../services/notifications";
import { PushNotif } from "../types/General";
import moment from "moment";
import DehazeOutlinedIcon from "@mui/icons-material/DehazeOutlined";
interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const [notifcationMethod] = useLazyReceiveNotificationQuery();
  const [logoutMethod] = usePostLogoutMutation();
  const [getUser, { isLoading }] = useLazyGetUserQuery();
  const [openLogout, setOpenLogout] = useState<boolean>(false);
  const [rows, setRows] = useState<PushNotif[]>([]);

  const getNotification = async () => {
    try {
      const response = await notifcationMethod({
        page: 1,
        limit: 3,
        search: "",
      }).unwrap();
      if (response?.statusCode === 200) {
        setRows(response?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = async () => {
    try {
      const result = await logoutMethod({}).unwrap();
      if (result?.statusCode === 200) {
        removeFromStorage(STORAGE_KEYS.token);
        dispatch(resetAuth());
        secureLocalStorage.removeItem("permissions");
        secureLocalStorage.removeItem("role");
        removeFromStorage(STORAGE_KEYS.tempToken);
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);

    if (token) {
      try {
        const result = await getUser({}).unwrap();
        if (result?.statusCode === 200 && token) {
          dispatch(
            setCredentials({
              token: `${token}`,
              user: result?.data,
            })
          );
        }
      } catch (error: any) {
        console.log(error);
      }
    }
  };
  const user = useAuth();

  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);

    const userData = getFromStorage(STORAGE_KEYS.credentials);

    if (token) {
      dispatch(
        setCredentials({
          token: `${token}`,
          user: JSON.parse(`${userData}`),
        })
      );
      getUserDetails();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);

  useEffect(() => {
    getNotification();
  }, []);

  return (
    <Box className="site_header">
      <Loader isLoading={isLoading} />
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: `${SIDEBAR_WIDTH}px` },
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <div className="topbar_left">
            <h1 className="toggle_btn" onClick={handleSidebarToggle}>
              <DehazeOutlinedIcon />
            </h1>
          </div>
          <div className="topbar_right">
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <NotificationsActiveIcon />
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 20,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  {rows?.length > 3 && (
                    <Button
                      className="btn btn_primary sm"
                      onClick={() => navigate("/recieved-notifications")}
                    >
                      See All
                    </Button>
                  )}
                </Box>
                <ul className="noti_list">
                  {rows?.length
                    ? rows?.map((item) => (
                        <li key={item?._id}>
                          <figure>
                            <img
                              src={
                                item?.image ||
                                "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                          </figure>
                          <div className="noti_info">
                            <Typography component="h3">
                              {item?.title || ""}
                              <Typography component="span">
                                {moment(item?.createdAt, "YYYYMMDD").fromNow()}
                              </Typography>
                            </Typography>
                            <Typography component="p">
                              {item?.message || ""}
                            </Typography>
                          </div>
                        </li>
                      ))
                    : null}
                </ul>
              </Menu>
            </Box>

            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={user?.image || "/static/images/user_placeholder.png"}
                  alt=""
                />
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 15,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  My Profile
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/manage-profile/change-password")}
                >
                  <IconButton className="drpdwn_icns">
                    <LockIcon />
                  </IconButton>
                  Change Password
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenLogout(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
